/* eslint-disable arrow-body-style */
import { connect } from 'react-redux';
import Page from '../components/Page/Page';
import { RootState } from '../stores';
import { getFormState } from '../stores/form/formSelector';

const mapStateToProps = (state: RootState) => {
  return {
    visibility: state.visibility,
    formInitialState: getFormState(state),
  };
};

export default connect(mapStateToProps)(Page);
